import { List, ListItem } from "@op/opds.opux";
import { LogoOP } from "@op/opds.opux-logo/op";
import { FormattedMessage } from "react-intl";
import { useReferenceNumbers } from "../../providers/ReferenceNumberProvider";

const ReferenceNumberList = () => {
  const { referenceNumbers } = useReferenceNumbers();

  return (
    <>
      <LogoOP className="logo" />
      <FormattedMessage tagName="h2" id="referenceNumbers" />
      <List className="reference-number-list" style={{ marginTop: 0 }}>
        {referenceNumbers.map((row) => (
          <ListItem key={row}>{row}</ListItem>
        ))}
      </List>
    </>
  );
};

export default ReferenceNumberList;
